import VideoJsAdapter from "../../adapters/videojs_adapter";

import Button from "../button";

export default class Index extends Button {

  constructor(player, options = {}){
    super(player, options);
    this.player = player;
  }

  buildCSSClass() {
    return 'vjs-big-navigation-button vjs-big-forward-button vjs-big-button';
  }

  handleClick(){
    this.player.trigger({
      type: 'vp-before-seeked',
      action: 'seekbutton'
    });
    this.player.currentTime(this.player.currentTime() + 10);
  }
}

Index.prototype.controlText_ = "Seek forward 10 seconds";
VideoJsAdapter.registerComponent('VpBigSeekForwardButton', Index);
